/**
 * Shared project media lives once at luca-miro/img/home-1/projects/.
 * Studio13 is served from .../studio-13/, so production uses a relative
 * path (../img/...) that works on Live Server and on the live site root.
 *
 * CRA `npm start` uses an absolute /img/... path served by setupProxy.js.
 * Override anytime with REACT_APP_MEDIA_BASE.
 */
function defaultMediaBase() {
  if (process.env.REACT_APP_MEDIA_BASE) {
    return process.env.REACT_APP_MEDIA_BASE;
  }
  if (process.env.NODE_ENV === 'development') {
    return '/img/home-1/projects';
  }
  // From /studio-13/ → sibling luca folder /img/home-1/projects/
  return '../img/home-1/projects';
}

export const MEDIA_BASE = defaultMediaBase().replace(/\/$/, '');

/** Build a URL under the shared media root (encodes each path segment). */
export function projectMedia(...segments) {
  const path = segments
    .filter(Boolean)
    .map((segment) =>
      String(segment)
        .split('/')
        .map((part) => encodeURIComponent(part))
        .join('/')
    )
    .join('/');
  return `${MEDIA_BASE}/${path}`;
}
